<template>
  <div class="upload">
    <el-upload class="upload-demo" ref="upload" :limit="1" :multiple="false" :show-file-list="true" :accept="accept" :action="uploadHost" :on-exceed="exceed" :data='uploadData' :before-upload='beforeUpload' :on-success="handleSuccess" :on-remove="handleRemove" :clearFiles="clearFiles" :file-list="file_list" :on-format-error="handleFormatError" :on-exceeded-size="handleMaxSize" :max-size="size">
      <!-- <i class="el-icon-upload"></i> -->
      <el-button type="primary" size="small">点击上传</el-button>
      <!-- <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">只能上传jpg/png/jpeg文件，且不超过{{size / 1024}}M</div> -->
    </el-upload>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from '@/libs/uploadFile'
import { getpublicImgUrl } from '@/api/base/api-upload'

export default {
  props: {
    max: {
      type: Number,
      default: 1
    },
    name: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: ''
    },
    size: {
      // eslint-disable-next-line vue/require-prop-type-constructor
      type: Number | String,
      default: 2048
    }
  },
  data () {
    return {
      showModal: false,
      // 附件上传路径
      uploadHost: '',
      type: 1,
      path: '',
      format: '[]',
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: '',
        oFileName: '',
        fileUrl: '',
        uploadRes: null
      },
      file_list: []
    }
  },
  watch: {
    value: {
      handler(nv) {
        if (nv && !this.file_list.length) {
          this.file_list = [{name: this.name, url: nv}]
        }
      },
      deep: true,
      immediate: true
    },
    file_list: {
      handler(nv) {
      },
      deep: true
    }
  },
  mounted () {
    this.init(0, 'public/product/')
  },
  methods: {
    // type 0公有 1私有
    init (type, path) {
      this.type = type
      this.path = path
    },
    exceed() {
      this.$message.warning('请删除文件后重新上传')
    },
    beforeUpload (file) {
      return oss(file.name, this.type, this.path).then(res => {
        this.uploadHost = res.host
        this.uploadData = res
        this.fileData.fileName = res.key
        this.fileData.oFileName = file.name
        this.fileData.fileUrl = res.key
      })
    },
    // 上传成功的回调函数
    handleSuccess (res, file, fileList) {
      this.uploadRes = res
      if (this.type === 0) {
        // 获取公有链接
        getpublicImgUrl(this.fileData.fileName).then(res => {
          if (res.code === 0) {
            this.fileData.fileUrl = res.data
            this.fileData.name = this.fileData.fileName
            this.fileData.url = res.data
            this.$emit('childByValue', this.fileData)
            this.$emit('input', res.data)
            this.file_list = [this.fileData]
          } else {
            this.$message.success('获取图片链接失败')
          }
        })
      }
    },
    closeHandle () {
      this.showModal = false
    },
    ok () {
    },
    clearFiles () {
      this.fileData = {
        fileName: '',
        fileUrl: '',
        uploadRes: null
      }
      this.file_list = []
    },
    handleRemove (file) {
      // 实现缩略图模板时删除文件
      let fileList = this.$refs.upload.uploadFiles;
      let index = fileList.findIndex( fileItem => {
        return fileItem.uid === file.uid
      })
      fileList.splice(index, 1)
    },
    handleFormatError (file) {
      this.$message({
        message: '图片格式错误',
        type: 'warning'
      })
    },
    handleMaxSize (file) {
      const size = parseInt(this.size / 1024)
      this.$message({
        message:`图片${file.name}不能超过${size}M`,
        type: 'warning'
      })
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
